export type {
  FireworksEmbeddingModelId,
  FireworksEmbeddingProviderOptions,
} from './fireworks-embedding-options';
export { FireworksImageModel } from './fireworks-image-model';
export type { FireworksImageModelId } from './fireworks-image-options';
export { fireworks, createFireworks } from './fireworks-provider';
export type {
  FireworksProvider,
  FireworksProviderSettings,
  FireworksErrorData,
} from './fireworks-provider';
export { VERSION } from './version';
